import { useState, useEffect, useRef, useCallback } from "react";
import { getbaseURL, getapiKey } from "../api/axios";
const CityAutosuggest = ({ onSelect, placeholder = "Search city...", form }) => {
    const [query, setQuery] = useState(form.FromCity || "");
    const [suggestions, setSuggestions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [open, setOpen] = useState(false);
    const [activeIdx, setActiveIdx] = useState(-1);
    const debounceRef = useRef(null);
    const inputRef = useRef(null);
    const fetchCities = useCallback(async (searchTerm) => {
        setLoading(true);
        try {
            const res = await fetch(
                `${getbaseURL()}/hotel/v1/city_search?keyword=${encodeURIComponent(searchTerm)}`,
                {
                    method: "GET",
                    headers: {
                        Authorization: `Bearer ${getapiKey()}`,
                        Accept: "application/json",
                        "Content-Type": "application/json",
                    },
                }
            );
            const data = await res.json();
            const sorted = [...data].sort((a, b) => {
                const q = searchTerm.toLowerCase();
                const aName = a.cityName.toLowerCase();
                const bName = b.cityName.toLowerCase();

                const aExact = aName === q;
                const bExact = bName === q;
                const aStarts = aName.startsWith(q);
                const bStarts = bName.startsWith(q);

                if (aExact !== bExact) return aExact ? -1 : 1;       // exact match first
                if (aStarts !== bStarts) return aStarts ? -1 : 1;    // starts with next
                return aName.localeCompare(bName);                    // alphabetical last
            });

            setSuggestions(sorted);
            setOpen(data.length > 0);
        } catch (err) {
            console.error("City fetch error:", err);
            setSuggestions([]);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        if (query.length < 2) {
            setSuggestions([]);
            setOpen(false);
            return;
        }
        clearTimeout(debounceRef.current);
        debounceRef.current = setTimeout(() => fetchCities(query), 300);
        return () => clearTimeout(debounceRef.current);
    }, [query, fetchCities]);

    const handleSelect = (city) => {
        setQuery(city.cityName);
        setOpen(false);
        setSuggestions([]);
        onSelect?.(city);
    };

    const handleKeyDown = (e) => {
        // if (!open) return;
        // if (e.key === "ArrowDown") setActiveIdx(i => Math.min(i + 1, suggestions.length - 1));
        // if (e.key === "ArrowUp") setActiveIdx(i => Math.max(i - 1, 0));
        // if (e.key === "Enter" && activeIdx >= 0) handleSelect(suggestions[activeIdx]);
        // if (e.key === "Escape") setOpen(false);
    };

    const highlight = (text) => {
        const idx = text.toLowerCase().indexOf(query.toLowerCase());
        if (idx === -1) return text;
        return (
            <>
                {text.slice(0, idx)}
                <span style={{ fontWeight: 600 }}>{text.slice(idx, idx + query.length)}</span>
                {text.slice(idx + query.length)}
            </>
        );
    };
    const wrapperRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
                setOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    return (
        <div style={{ position: "relative", width: "100%" }} ref={wrapperRef} >
            <input
                ref={inputRef}
                type="text"
                value={query}
                className="w-full border border-gray-300 rounded-md p-2.5 text-sm focus:ring-1 focus:ring-blue-600 outline-none"
                onChange={(e) => { setQuery(e.target.value); setActiveIdx(-1); }}
                onKeyDown={handleKeyDown}
                // onBlur={() => setTimeout(() => setOpen(false), 150)}
                placeholder={placeholder}
            />
            {loading && <span style={{ position: "absolute", right: 12, top: "50%", transform: "translateY(-50%)" }}>⏳</span>}

            {open && (
                <ul style={{
                    position: "absolute", top: "100%", left: 0, right: 0, zIndex: 100,
                    background: "#fff", border: "1px solid #ddd", borderRadius: 8,
                    maxHeight: 260, overflowY: "auto", padding: 0, margin: "4px 0 0",
                    listStyle: "none", boxShadow: "0 4px 12px rgba(0,0,0,0.1)"
                }}>
                    {suggestions.map((city, i) => (
                        <li
                            key={city.id}
                            onMouseDown={() => handleSelect(city)}
                            onMouseEnter={() => setActiveIdx(i)}
                            style={{
                                padding: "10px 14px",
                                borderBottom: "1px solid #f0f0f0",
                                background: i === activeIdx ? "#f5f5f5" : "#fff",
                                cursor: "pointer"
                            }}
                        >
                            <div style={{ fontWeight: 500 }}>{highlight(city.cityName)}</div>
                            <div style={{ fontSize: 11, color: "#888", marginTop: 2 }}>
                                {city.fullRegionName}
                            </div>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default CityAutosuggest;